import { EventEmitter, Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Custom, Container, InfoRadicationDocComponent, ButtonDownloadReviewComponent, ButtonDownloadComponent } from '@app/shared';
import { BaseControl, DateTimePicker, Textbox } from '@app/shared/dynamic-form';
import { ConfigFields } from '@app/shared/task/shared/form-service';


@Injectable()
export class InternalTaskInformationFormService {
  // se emite cada vez que se realiza una accion con los botones de la tabla de stickers
  accionSticker: EventEmitter<any> = new EventEmitter();
  accion: EventEmitter<any> = new EventEmitter();
  settings = {};
  settingsStickers = {};
  constructor() {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'La tarea actual no contiene documentos',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        clasificacion: {
          editable: false,
          addable: false,
          title: 'Nombre documento',
          filter: {
            inputClass: 'form-control',
          },
          type: 'custom',
          renderComponent: InfoRadicationDocComponent,
        },
        documentos_detalle: {
          title: 'Acciones a realizar',
          filter: false,
          type: 'custom',
          renderComponent: ButtonDownloadReviewComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };
    this.settingsStickers = {
      mode: 'external',
      noDataMessage: 'No hay rótulos disponibles',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        nombre: {
          editable: false,
          addable: false,
          class: 'prueba',
          title: 'Nombre',
          filter: {
            inputClass: 'form-control',
          },
        },
        action: {
          title: 'Acción',
          filter: false,
          type: 'custom',
          renderComponent: ButtonDownloadComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accionSticker.emit(data);
            });
          }
        },
      },
    };
  }

  getFields(task: Partial<ConfigFields>, templetesFomr: any, options: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 1,
        controls: [
          new DateTimePicker({
            key: 'tPInicio',
            label: 'Fecha inicial:',
            value: task && task.fecha_activacion ? task.fecha_activacion : null,
            size: 'col-md-12',
            placeholder: 'DD/MM/AAAA HH:MM',
            validations: {
              validators: [Validators.required]
            },
            disabled: !task.activo
          }),
        ],
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 1,
        controls: [
          new DateTimePicker({
            key: 'tPFinal',
            label: 'Fecha finalizacion:',
            value: task && task.fecha_finalizacion ? task.fecha_finalizacion : null,
            size: 'col-md-12',
            placeholder: 'DD/MM/AAAA HH:MM',
            disabled: !task.activo
          }),
        ],
      }),
      new Custom({
        key: 'cboestado',
        label: 'Estado',
        template: templetesFomr,
        placeholder: 'Seleccione el estado',
        value: task && task.tarea_estado.id ? task.tarea_estado.id : null,
        options: options ? options : [],
        order: 3,
        size: 'col-md-12',
        validations: {
          validators: [Validators.required]
        },
        disabled: !task.activo
      }),
      new Textbox({
        key: 'chActivo',
        type: 'checkbox',
        value: task && task.activo ? task.activo : false,
        label: 'Activa',
        order: 4
      })
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-flow/internal-task-information/shared/internal-task-information.form.service.ts